import Lightbox from './Lightbox';
import { useAsyncValue } from 'framework/utils';
import { AsyncLightboxProps } from './lightboxTypes';

const AsyncLightbox = ({ onDownload = () => {}, photos: photosPromises, ...props }: AsyncLightboxProps) => {
  const photos = useAsyncValue(() => Promise.all(photosPromises));

  return !!photos?.length && <Lightbox onDownload={onDownload} {...props} photos={photos} />;
};

export default AsyncLightbox;
